export { default as ConsentFooterContent } from './ConsentFooterContent';
export type { TConsentFooterContentProps } from './types';
